module.exports = __webpack_public_path__ + "assets/media/pb_video.31c8fc74.mp4";